import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { ArrowRight, Mail, Lock } from "lucide-react";
import SEO from "../components/SEO";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Vítejte zpět!");
      navigate(loc.state?.from || (u.role === "admin" ? "/admin" : "/ucet"));
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Neplatné údaje");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-10 pb-20 px-4 min-h-screen" data-testid="login-page">
      <SEO title="Přihlášení" noindex />
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl font-bold">Přihlášení</h1>
          <p className="text-zinc-600 mt-2 text-sm">Nemáte ještě účet? <Link to="/registrace" className="text-blue-600 font-semibold">Vytvořit účet</Link></p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-zinc-200 p-7 space-y-4">
          <div>
            <label className="text-xs font-semibold text-zinc-600">E-mail</label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400"/>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
                className="w-full pl-10 pr-3 py-2.5 rounded-xl border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"/>
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-zinc-600">Heslo</label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400"/>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
                className="w-full pl-10 pr-3 py-2.5 rounded-xl border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"/>
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full py-3 rounded-full font-semibold" data-testid="login-submit">
            {loading ? "Přihlašování…" : <span className="inline-flex items-center justify-center gap-2">Přihlásit se <ArrowRight className="w-4 h-4"/></span>}
          </button>
          <div className="text-center pt-1">
            <Link to="/zapomenute-heslo" className="text-xs text-zinc-500 hover:text-blue-600 hover:underline" data-testid="forgot-password-link">Zapomenuté heslo?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
